import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Form from 'flarum/common/components/Form';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import Stream from 'flarum/common/utils/Stream';
import { fetchRegistrationOptions, performRegistration, submitRegistration, PasskeyClientError } from '../lib/webauthn';
export default class AddPasskeyModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "deviceName", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.deviceName = Stream(this.guessDeviceName());
  }
  className() {
    return 'AddPasskeyModal Modal--small';
  }
  title() {
    return app.translator.trans('datlechin-passkey.forum.settings.add_modal.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, this.fields().toArray()));
  }
  fields() {
    const fields = new ItemList();
    fields.add('deviceName', m("div", {
      className: "Form-group"
    }, m("label", {
      htmlFor: "passkey-device-name"
    }, app.translator.trans('datlechin-passkey.forum.settings.add_modal.device_name_label')), m("input", {
      id: "passkey-device-name",
      className: "FormControl",
      placeholder: app.translator.trans('datlechin-passkey.forum.settings.add_modal.device_name_placeholder'),
      bidi: this.deviceName,
      maxlength: 64,
      disabled: this.loading
    })), 30);
    fields.add('submit', m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('datlechin-passkey.forum.settings.add_modal.register_button'))), -10);
    return fields;
  }
  onsubmit(e) {
    var _this$deviceName;
    e.preventDefault();
    const trimmed = ((_this$deviceName = this.deviceName()) != null ? _this$deviceName : '').trim();
    if (trimmed === '') return;
    this.loading = true;
    (async () => {
      const options = await fetchRegistrationOptions();
      const credential = await performRegistration(options);
      await submitRegistration(credential, trimmed);
    })().then(() => {
      var _this$attrs$onSuccess, _this$attrs;
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('datlechin-passkey.forum.settings.alerts.registration_succeeded'));
      (_this$attrs$onSuccess = (_this$attrs = this.attrs).onSuccess) == null || _this$attrs$onSuccess.call(_this$attrs);
      this.hide();
    }).catch(err => {
      var _messageByKind$err$ki;
      this.loaded();

      // Cancellation is silent: user dismissed the native prompt or it timed
      // out. They know what they did, no toast needed.
      if (err instanceof PasskeyClientError && err.kind === 'cancelled') {
        return;
      }

      // Server-side failures (401 session expired, 422 validation, 429
      // throttled, ...) are not PasskeyClientError. Flarum's default
      // request handler has already shown an alert for those, so we skip
      // surfacing a second message here.
      if (!(err instanceof PasskeyClientError)) {
        return;
      }
      const messageByKind = {
        invalid_state: 'datlechin-passkey.forum.settings.alerts.registration_already_exists',
        security: 'datlechin-passkey.forum.settings.alerts.registration_security_error',
        unsupported: 'datlechin-passkey.forum.settings.alerts.registration_unsupported'
      };
      const messageKey = (_messageByKind$err$ki = messageByKind[err.kind]) != null ? _messageByKind$err$ki : 'datlechin-passkey.forum.settings.alerts.registration_failed';
      app.alerts.show({
        type: 'error'
      }, app.translator.trans(messageKey));
    });
  }

  /** "{browser} on {os}" matching core's AccessTokenResource session devices. */
  guessDeviceName() {
    const data = navigator.userAgentData;
    if (data) {
      var _data$platform, _ref, _data$brands$find$bra, _data$brands$find, _data$brands$;
      const platform = (_data$platform = data.platform) != null ? _data$platform : '';
      const browser = (_ref = (_data$brands$find$bra = (_data$brands$find = data.brands.find(b => /Chrome|Edge|Opera|Brave/i.test(b.brand))) == null ? void 0 : _data$brands$find.brand) != null ? _data$brands$find$bra : (_data$brands$ = data.brands[0]) == null ? void 0 : _data$brands$.brand) != null ? _ref : '';
      const friendlyBrowser = browser.replace(/^Google /, '').replace(/Microsoft /, '');
      if (data.mobile && platform === 'Android') return browserOn(friendlyBrowser, 'Android');
      if (platform === 'macOS') return browserOn(friendlyBrowser, 'Mac');
      if (platform === 'Windows') return browserOn(friendlyBrowser, 'Windows');
      if (platform === 'Linux') return browserOn(friendlyBrowser, 'Linux');
      if (platform === 'Chrome OS') return browserOn(friendlyBrowser, 'Chromebook');
    }
    const ua = navigator.userAgent;
    const browser = /Edg\//.test(ua) ? 'Edge' : /Firefox\//.test(ua) ? 'Firefox' : /CriOS\//.test(ua) ? 'Chrome' : /OPR\/|Opera/.test(ua) ? 'Opera' : /Chrome\//.test(ua) ? 'Chrome' : /Safari\//.test(ua) ? 'Safari' : '';
    let device = '';
    if (/iPhone/.test(ua)) {
      device = 'iPhone';
    } else if (/iPad/.test(ua)) {
      device = 'iPad';
    } else if (/Android/.test(ua)) {
      var _match$;
      const match = ua.match(/Android[^;]*;\s*([^;)]+?)(?:\s+Build|\))/);
      device = (match == null || (_match$ = match[1]) == null ? void 0 : _match$.trim()) || 'Android';
    } else if (/Macintosh|Mac OS X/.test(ua)) {
      device = 'Mac';
    } else if (/Windows NT/.test(ua)) {
      device = 'Windows';
    } else if (/CrOS/.test(ua)) {
      device = 'Chromebook';
    } else if (/Linux/.test(ua)) {
      device = 'Linux';
    }
    return browserOn(browser, device) || 'Passkey';
  }
}
function browserOn(browser, device) {
  if (browser && device) return "".concat(browser, " on ").concat(device);
  return browser || device;
}
flarum.reg.add('datlechin-passkey', 'forum/components/AddPasskeyModal', AddPasskeyModal);